<template>
  <div class="editor">
    <div class="editor-header" v-if="editor">
      <button type="button" @click="editor.chain().focus().toggleHeading({ level: 3 }).run()" :class="{ 'is-active': editor.isActive('heading', { level: 3 }) }">
        <span style="font-weight:bold">Heading</span>
      </button>
      <button type="button" @click="editor.chain().focus().setParagraph().run()" :class="{ 'is-active': editor.isActive('paragraph') }">
        <span>Body</span>
      </button>
      <button type="button" @click="editor.chain().focus().toggleBold().run()" :class="{ 'is-active': editor.isActive('bold') }">
        <span style="font-weight:bold">B</span>
      </button>
      <button type="button" @click="editor.chain().focus().toggleItalic().run()" :class="{ 'is-active': editor.isActive('italic') }">
        <span>/</span>
      </button>
      <button type="button" @click="editor.chain().focus().toggleUnderline().run()" :class="{ 'is-active': editor.isActive('underline') }">
        <span style="text-decoration:underline">U</span>
      </button>
      <button type="button" @click="setLink">
        <span>Link</span>
      </button>
    </div>
    <editor-content class="editor-content" :editor="editor" />
    <el-dialog
      title="Set Link" :model-value="flagVisibleSetLink" width="30%"
      :before-close="handleCloseSetLink"
    >
      <el-input v-model="linkUrl" placeholder="Link URL"></el-input>
      <template #footer>
        <span class="dialog-footer">
          <el-button size="small" @click="handleCloseSetLink">CANCEL</el-button>
          <el-button size="small" class="el-btn-blue" @click="handleSaveSetLink">SET</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { Editor, EditorContent } from '@tiptap/vue-3'
import StarterKit from '@tiptap/starter-kit'
import Underline from '@tiptap/extension-underline'
import Link from '@tiptap/extension-link'

export default {
  name: 'TabEditor',
  props: {
    actionType: String,
    actionItem: String
  },
  emits: ['updateContent'],
  components: {
    EditorContent
  },
  data () {
    return {
      editor: null,
      flagVisibleSetLink: false,
      linkUrl: ''
    }
  },
  created: function () {
  },
  mounted () {
    this.initEditor()
  },
  beforeUnmount () {
    this.editor.destroy()
  },
  computed: {
  },
  watch: {
    actionItem: {
      handler: function (val, oldVal) {
        if (val !== oldVal) {
          this.editor.commands.setContent(val, false)
        }
      },
      deep: true
    }
  },
  methods: {
    initEditor: function () {
      this.editor = new Editor({
        content: '',
        extensions: [
          StarterKit,
          Underline,
          Link.configure({
            HTMLAttributes: { target: '_blank' },
            openOnClick: true
          })
        ],
        onUpdate: () => {
          this.$emit('updateContent', this.actionType, this.editor.getHTML())
        }
      })
    },
    setLink: function () {
      const previousUrl = this.editor.getAttributes('link').href
      this.linkUrl = previousUrl
      this.flagVisibleSetLink = true
    },
    handleCloseSetLink: function () {
      this.flagVisibleSetLink = false
    },
    handleSaveSetLink: function () {
      this.editor.chain().focus().extendMarkRange('link').setLink({ href: this.linkUrl }).run()
      this.flagVisibleSetLink = false
    }
  }
}
</script>
<style scoped lang="scss">
.editor {
  border: 1px solid #F2F2F2;
  .editor-header {
    display: flex;
    align-items: center;
    background-color: #F2F2F2;
    height: 40px;
    padding: 0 10px;
    button {
      background-color: #F2F2F2;
      border: none;
      margin: 0 15px 0 0;
      border-radius: 4px;
      cursor: pointer;
      line-height: 20px;
      &:last-child {
        margin: 0px;
      }
      &.is-active {
        background-color: black;
        color: white;
      }
    }
  }
  .editor-content {
    padding: 10px;
  }
}
</style>
